import { render, staticRenderFns } from "./ScheduledPaymentChipStatusComponent.vue?vue&type=template&id=64112796&"
import script from "./ScheduledPaymentChipStatusComponent.vue?vue&type=script&lang=js&"
export * from "./ScheduledPaymentChipStatusComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports